var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ApiActionService = /** @class */ (function (_super) {
            __extends(ApiActionService, _super);
            function ApiActionService(breeze, $q, $http) {
                var _this = _super.call(this, breeze, $q) || this;
                _this.$http = $http;
                return _this;
            }
            ApiActionService.prototype.getApiActions = function (processConfigurationId) {
                var expand = "objectQuery.myInputObjectSchema, " +
                    "objectQuery.myProjectionObjectSchema, " +
                    "inputObjectSchema.properties, " +
                    "outputObjectSchema.properties, " +
                    "apiSchemaMappings";
                var query = this.breezeModule.EntityQuery
                    .from("ApiActions")
                    .where('processConfiguration_id', '==', processConfigurationId)
                    .expand(expand);
                return this.executeQuery(query);
            };
            ApiActionService.prototype.runApiAction = function (processTypeId, apiActionId) {
                var d = this.$q.defer();
                this.$http.post('./api/ApiAction/' + apiActionId + "/ProcessType/" + processTypeId, null).then(function (r) {
                    d.resolve(r.data);
                });
                return d.promise;
            };
            ApiActionService.prototype.getApiConfigurations = function () {
                //console.log('api');
                var query = this.breezeModule.EntityQuery
                    .from("ApiActions")
                    .where('isActive', '==', true)
                    .expand("inputObjectSchema.properties, outputObjectSchema.properties, processConfiguration.myProcessType");
                return this.executeQuery(query);
            };
            ApiActionService.prototype.getApiActionForField = function (uniqueId) {
                var p1 = new breeze.Predicate('isActive', '==', true);
                var p2 = new breeze.Predicate('uniqueId', '==', uniqueId);
                var pred = breeze.Predicate.and([p1, p2]);
                var query = this.breezeModule.EntityQuery
                    .from("ApiActions")
                    .where(pred)
                    .expand("outputObjectSchema.properties");
                return this.executeQuery(query);
            };
            ApiActionService.prototype.createApiAction = function () {
                var apiAction = this.createNewEntity("ApiAction");
                apiAction.uniqueId = services.UtilityService.generateGuidComb();
                return apiAction;
            };
            return ApiActionService;
        }(services.DataService));
        services.ApiActionService = ApiActionService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('ApiActionService', ['breeze', '$q', '$http']);
